import React from 'react';
import classNames from 'classnames';
import styles from './WholeNumberInputControl.module.scss';

export interface IWholeNumberInputControlProps {
    allowNegativeValues?: boolean;
    className?: string;
    disabled?: boolean;
    name?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    style?: object;
    value: string | number | undefined;
}

export function WholeNumberInputControl(props: IWholeNumberInputControlProps) {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        const regex = props.allowNegativeValues ? /^-?\d+$/ : /^[\d]*$/;

        const isNonDecimalNumeric = regex.test(inputValue) || inputValue === '';
        if (isNonDecimalNumeric) {
            props.onChange(e);
        }
    };

    const inputClasses = classNames(
        styles.input,
        'form-control d-inline-block',
        props.className
    );

    return (
        <input
            type="number"
            className={inputClasses}
            disabled={props.disabled}
            name={props.name}
            onChange={handleChange}
            placeholder={props.placeholder}
            style={props.style}
            value={props.value ?? ''}
        />
    );
}
